module.exports = __webpack_public_path__ + "static/media/CreateExercise_Sketch.1ed33a47.png";